import React from 'react';

const BlogIntroSection = () => {
  return (
    <section className="blog-intro-section">
      <div className="container">
        <div className="blog-intro-section__content">
          <div className="blog-intro-section__text">
            <p>
              This is where the good vibes live... stories, tips, and everything you didn't know you needed
              before hitting the water with us. Whether you're planning your first boat day, coming back for
              your yearly friend's trip, or just daydreaming about salty air and champagne toasts... you're in
              the right place.
            </p>
            <p>
              We'll be sharing our favorite routes, packing tips, restaurant stops, sunset views, and even
              behind-the-scenes moments from our amazing crew. Think of this as your go-to guide for living
              your best boat life in Miami.
            </p>
            <p>
              📸 Been on board with us recently? Got a cool story or epic photos? We'd love to feature
              you! Send them our way and you might just see your crew on the blog.
            </p>
            <p>
              Let's make waves together. See you out there. 😎
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogIntroSection;




